<template>
  <div :class="className" class="title-widget">
    <div>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    align: {
      type: String,
      default: "center",
      validator: (val) => ["left", "center", "right"].includes(val),
    },
    small: {
      type: Boolean,
      default: false,
    },
    dark: {
      type: Boolean,
      default: false,
    },
    hasUnderline: {
      type: Boolean,
      default: true,
    },
    link: {
      type: String,
    },
  },
  computed: {
    className() {
      const alignClass = {
        left: "text-left align-start",
        center: "text-center align-center",
        right: "text-right align-end",
      };

      const className = [
        "d-flex flex-column justify-center",
        alignClass[this.align],
        !this.dark ? "title-widget--light" : "title-widget--dark",
        !this.small && "text-h5 text-md-h4",
        this.link && "title-widget--link",
      ];

      return className;
    },
    attrs() {
      const attrs = {};

      if (this.link) {
        attrs.to = this.link;
      }

      return attrs;
    },
    component() {
      return this.link ? "router-link" : "span";
    },
  },
};
</script>

<style lang="scss" scoped>
.title-widget--light {
  --text: var(--v-primary-base);
}

.title-widget--dark {
  --text: #ffffff;
}

.title-widget {
  > * {
    color: var(--text) !important;
    font-weight: bold !important;
    letter-spacing: 1.85px !important;
  }
}
</style>
